import React from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// Custom styled step with subtle animation
const AnimatedStep = styled(Step)(({ theme }) => ({
  "& .MuiStepIcon-root": {
    transition: "transform 0.3s ease, color 0.3s ease",
    "&.Mui-active": {
      color: theme.palette.primary.main,
      transform: "scale(1.2)",
    },
    "&.Mui-completed": {
      color: theme.palette.primary.main,
    },
  },
  "& .MuiStepConnector-line": {
    transition: "background-color 0.3s ease",
  },
}));

const AnimatedStepper = ({ activeStep, sx }) => {
  return (
    <Stepper
      activeStep={activeStep}
      sx={{
        width: { xs: "100%", md: "200px" },
        margin: "0 auto",
        mb: 4,
        mt: 4,
        ...sx,
      }}
    >
      {[1, 2, 3].map((step) => (
        <AnimatedStep key={step}>
          <StepLabel></StepLabel>
        </AnimatedStep>
      ))}
    </Stepper>
  );
};

export default AnimatedStepper;
